import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

export const SettingsDetailsPageTabs = ({
  currentTab,
}: {
  currentTab: any
}) => {
  return (
    <Tabs value={currentTab}>
      <Tab
        label="EULA"
        value={`/Settings/SettingsDetailsPageEULA`}
        to={`/Settings/EULA`}
        component={Link}
      />
      <Tab
        label="Patron App"
        value={`/Settings/SettingsDetailsPagePatronApp`}
        to={`/Settings/PatronApp`}
        component={Link}
      />
      <Tab
        label="Celebrations"
        value={`/Settings/SettingsDetailsPageCelebrations`}
        to={`/Settings/Celebrations`}
        component={Link}
      />
    </Tabs>
  )
}
